import MiniHeaders from "./mini-headers";
import React from "react";
import {trainingDescription} from "../data/mock-date";
import '../components-css/training-course.scss';


const TrainingCourse = () => {
    return (
        <div>
            <div className={'blocks-wrapper'}>
                <MiniHeaders headerName={'Վերապատրաստման Կուրս'}/>
                <>
                    <div className={'training-headers'}>
                        <h3>Մեկնարկը՝ Փետրվարի 15</h3>
                        <h3>Արժեքը՝ 130000 դրամ</h3>
                        <h3>Շաբաթական 3 դաս՝ ուղիղ միացումով</h3>
                        <h4>Թեմաներն են՝</h4>
                    </div>
                    <ul className={'features'}>
                        {
                            trainingDescription.map((item, index) => {
                                return (
                                    <li key={index} className={'list-item'}>
                                        <span>{index + 1}.</span>
                                        <p className={'li-item'}>{item}</p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </>
            </div>
        </div>
    );
};

export default TrainingCourse;
